enum UserDictionaryTypes {
  countries = 1,
  voivodeships = 2,
  taxOffices = 3
}

export default UserDictionaryTypes;